/* Enduristan NL restyle 2026: EN Past-op-mijn-tas hulp v1.5 (29-10). Geladen door sections/en-article-body.liquid v1.4 als het artikel
   een element [data-en-cx-tool] of [data-en-cx-img] bevat. Twee manieren: Ik heb een tas (per plek wat past) of Ik heb een accessoire.
   Foto en prijs komen live uit /products/[handle].js. Bron data: officieel compatibiliteitsoverzicht Enduristan (foto Roel, 29-10-2026).
   Direct openen via #tas=hailstorm-35 of #accessoire=sidekick-4 (bijvoorbeeld vanaf een productpagina). Stijl: assets/en-art-compat.css.
   v1.1: na een keuze klappen de tegels in tot een balk met de gekozen tas of accessoire en een knop Wijzig.
   v1.2: plekken als blokken naast elkaar (2x2 op desktop), accessoires en tassen als compacte regels met kleine foto en prijs.
   v1.3: plekken zijn uitklapbaar; op mobiel staat alleen de eerste plek open.
   v1.4: vult ook losse producttegels [data-en-cx-img] in elk artikel met foto en prijs (stijl assets/en-art-tiles.css).
   v1.5 (29-10-2026): NL/EN. Taal uit Shopify.locale (of html lang). Teksten via L(nl, en), data (inhoud, groepen, plekken) via tr().
   Hashes #tas= en #accessoire= blijven in beide talen gelijk. */
(function () {
  'use strict';
  var root = document.querySelector('[data-en-cx-tool]');
  var tiles = document.querySelectorAll('[data-en-cx-img]');
  if (!root && !tiles.length) return;

  var EN = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  function L(nl, en) { return EN ? en : nl; }
  var TR = { 'Tanktassen': 'Tank bags', 'Front en rear': 'Front and rear', 'Zijkant': 'Side', '1 fles': '1 bottle', '2 flessen': '2 bottles' };
  function tr(s) {
    if (!EN) return s;
    if (TR[s]) return TR[s];
    var m = /^(\d+) liter$/.exec(s || '');
    if (m) return m[1] + (m[1] === '1' ? ' litre' : ' litres');
    return s;
  }

  var D = {"a":[["SK01","Sidekick 01","sidekick-1","1x2","1 liter"],["SK02","Sidekick 02","sidekick-2","1x3","2 liter"],["BH201","Bottle Holster 2.01","bottle-holster-2-01","1x3","1 fles"],["SK03","Sidekick 03","sidekick-3","2x2","3 liter"],["SK04","Sidekick 04","sidekick-4","2x3","4 liter"],["BH202","Bottle Holster 2.02","bottle-holster-2-02","2x3","2 flessen"],["SK10","Sidekick 10","sidekick-10","2x3","10 liter"],["SK05","Sidekick 05","sidekick-5","2x4","5 liter"],["SK20","Sidekick 20","sidekick-20","3x4","20 liter"]],"g":[["Rackless",[["Hailstorm 35","hailstorm-35",[["Flap","1x3",["SK01","SK02","BH201"]],["Rear","2x4",["SK01","SK02","BH201","SK03","SK04","BH202","SK05"]],["Front","2x2",["SK01","SK03"]],["Center Plate","",["SK10"]]]],["Hailstorm 50","hailstorm-50",[["Flap","1x3",["SK01","SK02","BH201"]],["Rear","2x4",["SK01","SK02","BH201","SK03","SK04","BH202","SK05"]],["Front","2x2",["SK01","SK03"]],["Center Plate","",["SK20"]]]],["Blizzard 2.15","blizzard-2-15",[["Flap","1x3",["SK01","SK02","BH201"]],["Rear","1x3",["SK01","SK02","BH201"]],["Front","1x2",["SK01"]],["Center","2x3",["SK01","SK02","BH201","SK03","SK04","BH202","SK10"]]]],["Blizzard 2.25","blizzard-2-25",[["Flap","2x3",["SK01","SK02","BH201","SK03","SK04","BH202"]],["Rear","2x3",["SK01","SK02","BH201","SK03","SK04","BH202"]],["Front","2x2",["SK01","SK03"]],["Center","2x3",["SK01","SK02","BH201","SK03","SK04","BH202","SK10"]]]],["Blizzard 2.35","blizzard-2-35",[["Flap","2x3",["SK01","SK02","BH201","SK03","SK04","BH202"]],["Rear","2x3",["SK01","SK02","BH201","SK03","SK04","BH202"]],["Front","2x2",["SK01","SK03"]],["Center","2x3",["SK01","SK02","BH201","SK03","SK04","BH202","SK10"]]]]]],["Panniers",[["Monsoon Evo 2.25","monsoon-evo-2-25",[["Flap","1x4",["SK01","SK02","BH201"]],["Front en rear","1x4",["SK01","SK02","BH201"]]]],["Monsoon Evo 2.35","monsoon-evo-2-35",[["Flap","2x4",["SK01","SK02","BH201","SK03","SK04","BH202","SK05"]],["Front en rear","2x4",["SK01","SK02","BH201","SK03","SK04","BH202","SK10","SK05"]]]]]],["Tail bags",[["Cyclone 35","cyclone-35",[["Rear","1x2",["SK01"]],["Top","2x4",["SK01","SK02","BH201","SK03","SK04","BH202","SK10","SK05"]]]],["Cyclone 55","cyclone-55",[["Rear","1x2",["SK01"]],["Top","3x4",["SK01","SK02","BH201","SK03","SK04","BH202","SK10","SK05","SK20"]]]],["Sidekick 10","sidekick-10",[["Zijkant","1x2",["SK01"]]]],["Sidekick 20","sidekick-20",[["Zijkant","1x3",["SK01","SK02","BH201"]]]]]],["Tanktassen",[["Sandstorm 5.01","sandstorm-5-01",[["Top","1x1",[]]]],["Sandstorm 5.03","sandstorm-5-03",[["Top","1x2",["SK01"]]]],["Sandstorm 5.06","sandstorm-5-06",[["Top","2x3",["SK01","SK02","BH201","SK03","SK04","BH202"]]]]]]]};

  var ACC = {}, ACC_BY_H = {}, BAGS = [], BAG_BY_H = {};
  D.a.forEach(function (x) {
    var a = { code: x[0], name: x[1], h: x[2], pad: x[3], vol: x[4] };
    ACC[a.code] = a; ACC_BY_H[a.h] = a;
  });
  D.g.forEach(function (g) {
    g[1].forEach(function (b) {
      var bag = { group: g[0], name: b[0], h: b[1], rows: b[2] };
      BAGS.push(bag); BAG_BY_H[bag.h] = bag;
    });
  });

  var MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return MAP[c]; }); }
  function size(p) { return p ? p.replace('x', '×') : L('eigen plaat', 'own plate'); }
  function money(c) {
    var p = (Number(c || 0) / 100).toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + p[0] + ',' + p[1];
  }
  var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  function prod(h) {
    if (!cache[h]) {
      cache[h] = fetch(root_url + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function imgUrl(p, w) {
    var img = p && p.featured_image;
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    return img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  Array.prototype.forEach.call(tiles, function (el) {
    prod(el.getAttribute('data-en-cx-img')).then(function (p) {
      if (!p) return;
      var u = imgUrl(p, 300);
      var box = el.querySelector('.en-cx-tile__img');
      if (u && box) box.innerHTML = '<img src="' + esc(u) + '" alt="" width="150" height="150" loading="lazy">';
      var pr = el.querySelector('.en-cx-tile__price');
      if (pr && p.price != null) pr.textContent = money(p.price);
    });
  });
  if (!root) return;

  var mode = 'bag', sel = null;

  function card(h, name, meta) {
    return '<a class="en-cx-row" href="' + root_url + 'products/' + esc(h) + '" data-cx-h="' + esc(h) + '">' +
      '<span class="en-cx-row__img"></span>' +
      '<span class="en-cx-row__txt"><span class="en-cx-row__name">' + esc(name) + '</span><span class="en-cx-row__meta">' + esc(meta) + '</span></span>' +
      '<span class="en-cx-row__price"></span></a>';
  }

  function fill(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cx-h]'), function (el) {
      prod(el.getAttribute('data-cx-h')).then(function (p) {
        if (!p) return;
        var u = imgUrl(p, 120);
        if (u) el.querySelector('.en-cx-row__img').innerHTML = '<img src="' + esc(u) + '" alt="" width="48" height="48" loading="lazy">';
        if (p.price != null) el.querySelector('.en-cx-row__price').textContent = money(p.price);
      });
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cx-img]'), function (el) {
      prod(el.getAttribute('data-cx-img')).then(function (p) {
        var u = imgUrl(p, 200);
        if (u) el.querySelector('.en-cx-opt__img').innerHTML = '<img src="' + esc(u) + '" alt="" width="100" height="100" loading="lazy">';
      });
    });
  }

  function tile(h, name) {
    return '<button type="button" class="en-cx-opt" data-cx-pick="' + esc(h) + '" data-cx-img="' + esc(h) + '" aria-pressed="' + (sel === h) + '">' +
      '<span class="en-cx-opt__img"></span><span class="en-cx-opt__name">' + esc(name) + '</span></button>';
  }

  function options() {
    if (mode === 'bag') {
      var html = '', last = '';
      BAGS.forEach(function (b) {
        if (b.group !== last) {
          if (last) html += '</div></div>';
          html += '<div class="en-cx-optgroup"><p class="en-cx-optlbl">' + esc(tr(b.group)) + '</p><div class="en-cx-opts">';
          last = b.group;
        }
        html += tile(b.h, b.name);
      });
      return html + '</div></div>';
    }
    var out = '<div class="en-cx-optgroup"><div class="en-cx-opts">';
    D.a.forEach(function (x) { out += tile(x[2], x[1]); });
    return out + '</div></div>';
  }

  function result() {
    if (!sel) {
      return '<p class="en-cx-hint">' + (mode === 'bag'
        ? L('Kies hierboven je tas. Je ziet dan per plek welke accessoires passen.', 'Choose your bag above to see which accessories fit in each position.')
        : L('Kies hierboven een accessoire. Je ziet dan op welke tassen het past.', 'Choose an accessory above to see which bags it fits.')) + '</p>';
    }
    var html = '';
    if (mode === 'bag') {
      var b = BAG_BY_H[sel];
      html += '<p class="en-cx-step"><span class="en-cx-step__n">2</span><span>' + L('Dit past erop, per plek', 'What fits, per position') + '</span></p>';
      html += '<div class="en-cx-grid">';
      var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      b.rows.forEach(function (r, i) {
        var n = r[2].length;
        html += '<details class="en-cx-pos"' + (!small || i === 0 ? ' open' : '') + '><summary class="en-cx-pos__head"><strong>' + esc(tr(r[0])) + '</strong><span>' + (r[1] ? L('plek ', 'position ') + esc(size(r[1])) : L('speciale plaat', 'special plate')) + '</span><em>' + n + (n === 1 ? L(' accessoire', ' accessory') : L(' accessoires', ' accessories')) + '</em></summary>';
        if (!r[2].length) {
          html += '<p class="en-cx-hint">' + L('Deze plek is te klein voor een accessoire. Kijk voor extra ruimte op je tank naar de Sandstorm 5.03 of 5.06.', 'This position is too small for an accessory. For extra space on your tank, take a look at the Sandstorm 5.03 or 5.06.') + '</p>';
        } else {
          html += '<div class="en-cx-rows">';
          r[2].forEach(function (c) { var a = ACC[c]; html += card(a.h, a.name, tr(a.vol)); });
          html += '</div>';
        }
        html += '</details>';
      });
      html += '</div>';
    } else {
      var a = ACC_BY_H[sel];
      var hits = [];
      BAGS.forEach(function (bg) {
        if (bg.h === a.h) return;
        var pos = bg.rows.filter(function (r) { return r[2].indexOf(a.code) > -1; }).map(function (r) { return tr(r[0]); });
        if (pos.length) hits.push({ b: bg, pos: pos });
      });
      html += '<p class="en-cx-step"><span class="en-cx-step__n">2</span><span>' + (EN ? 'Fits ' + hits.length + (hits.length === 1 ? ' bag' : ' bags') : 'Past op ' + hits.length + ' tassen') + '</span></p>';
      html += '<p class="en-cx-note">' + (EN
        ? 'Needs a position of at least ' + esc(size(a.pad)) + '. Each bag shows where it fits.'
        : 'Nodig: een plek van minimaal ' + esc(size(a.pad)) + '. Onder elke tas staat op welke plek.') + '</p>';
      html += '<div class="en-cx-rows en-cx-rows--2">';
      hits.forEach(function (x) { html += card(x.b.h, x.b.name, L('Op: ', 'On: ') + x.pos.join(', ').toLowerCase()); });
      html += '</div>';
    }
    return html;
  }

  function chosen() {
    var isBag = mode === 'bag';
    var name = isBag ? BAG_BY_H[sel].name : ACC_BY_H[sel].name;
    return '<div class="en-cx-chosen">' +
      '<span class="en-cx-chosen__img" data-cx-img="' + esc(sel) + '"><span class="en-cx-opt__img"></span></span>' +
      '<span class="en-cx-chosen__txt"><span class="en-cx-chosen__lbl">' + (isBag ? L('Jouw tas', 'Your bag') : L('Jouw accessoire', 'Your accessory')) + '</span><strong>' + esc(name) + '</strong></span>' +
      '<button type="button" class="en-cx-chosen__btn" data-cx-reset>' + L('Wijzig', 'Change') + '</button></div>';
  }

  function render(focus) {
    root.innerHTML =
      '<div class="en-cx-tabs" role="tablist" aria-label="' + L('Zoek op', 'Search by') + '">' +
        '<button type="button" role="tab" class="en-cx-tab" data-cx-mode="bag" aria-selected="' + (mode === 'bag') + '">' + L('Ik heb een tas', 'I have a bag') + '</button>' +
        '<button type="button" role="tab" class="en-cx-tab" data-cx-mode="acc" aria-selected="' + (mode === 'acc') + '">' + L('Ik heb een accessoire', 'I have an accessory') + '</button>' +
      '</div>' +
      (sel ? chosen() : '<p class="en-cx-step"><span class="en-cx-step__n">1</span>' + (mode === 'bag' ? L('Kies je tas', 'Choose your bag') : L('Kies je accessoire', 'Choose your accessory')) + '</p>' + options()) +
      '<div class="en-cx-res' + (sel ? ' is-on' : '') + '" aria-live="polite">' + result() + '</div>';
    fill(root);
    if (focus) {
      var top = root.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.5) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function setHash() {
    try { history.replaceState(null, '', sel ? (mode === 'bag' ? '#tas=' : '#accessoire=') + sel : location.pathname + location.search); } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cx-mode]');
    if (t) {
      var m = t.getAttribute('data-cx-mode');
      if (m !== mode) { mode = m; sel = null; setHash(); render(false); }
      return;
    }
    if (e.target.closest('[data-cx-reset]')) { sel = null; setHash(); render(true); return; }
    var p = e.target.closest('[data-cx-pick]');
    if (p) {
      var h = p.getAttribute('data-cx-pick');
      sel = sel === h ? null : h;
      setHash();
      render(!!sel);
    }
  });

  var m = /^#(tas|accessoire)=([a-z0-9-]+)$/.exec(location.hash || '');
  if (m) {
    if (m[1] === 'tas' && BAG_BY_H[m[2]]) { mode = 'bag'; sel = m[2]; }
    if (m[1] === 'accessoire' && ACC_BY_H[m[2]]) { mode = 'acc'; sel = m[2]; }
  }
  root.classList.add('is-ready');
  render(false);
  if (sel) root.scrollIntoView({ block: 'start' });
})();
